import { PersonOutlined, PlaceOutlined } from '@mui/icons-material'
import { Box, Grid, MenuItem, Typography, useTheme } from '@mui/material'

import OrderSearchResultIcon from '../../../images/orders/order-search-result.svg'
import useSharedStyles from '../../../utils/shared.styles'
import HighlightText from '../../highlight-text'
import useStyles from '../index.styles'

interface IResultOrderItemProps {
  shortOrderNumber: string
  orderType: string
  status: string
  folderName: string
  folderAddress: string
  accountNumber: string
  contactName: string
  contactEmail: string
  searchValue: string
  onClick: () => void
}

const ResultOrderItem = (props: IResultOrderItemProps) => {
  const { shortOrderNumber, orderType, status, folderName, folderAddress, accountNumber, contactName, contactEmail, searchValue, onClick } = props

  const classes = useStyles
  const sharedClasses = useSharedStyles
  const theme = useTheme()

  return (
    <MenuItem onClick={onClick} tabIndex={0} data-testid="search-result-item">
      <Grid
        container={true}
        wrap="nowrap"
        sx={{
          alignItems: 'flex-start',
        }}
      >
        <img src={OrderSearchResultIcon} style={classes.searchItemIcon(theme)} />
        <Box sx={classes.resultItemTextContainer}>
          <Typography variant="body1" className="fs-exclude" sx={sharedClasses.overflowText}>
            <HighlightText text={`${orderType} #${shortOrderNumber}`} query={searchValue} colorHighlight={true} />
            <Typography variant="caption" sx={classes.searchItemPrimaryTextCaption}>
              • <HighlightText text={status} query={searchValue} colorHighlight={true} />
            </Typography>
          </Typography>
          <Box sx={sharedClasses.overflowText}>
            {folderName && (
              <Typography variant="caption" className="fs-exclude" sx={sharedClasses.secondaryText}>
                <HighlightText text={folderName} query={searchValue} colorHighlight={true} />
              </Typography>
            )}
            {accountNumber && (
              <Typography variant="caption" className="fs-exclude" sx={sharedClasses.secondaryText}>
                {folderName && ' • '}Acct #<HighlightText text={accountNumber} query={searchValue} colorHighlight={true} />
              </Typography>
            )}
            {folderAddress && (
              <Typography variant="caption" className="fs-exclude" sx={sharedClasses.secondaryText}>
                <PlaceOutlined sx={{ ...classes.searchItemSecondaryTextIcon(theme), marginLeft: folderName ? 2 : 0 }} />
                <HighlightText text={folderAddress} query={searchValue} colorHighlight={true} />
              </Typography>
            )}
            {(contactName || contactEmail) && (
              <Typography variant="caption" className="fs-exclude" sx={sharedClasses.secondaryText}>
                <PersonOutlined sx={{ ...classes.searchItemSecondaryTextIcon(theme), marginLeft: folderName ? 2 : 0 }} />
                {contactName && <HighlightText text={contactName} query={searchValue} colorHighlight={true} />}
                {contactName && contactEmail && ' • '}
                {contactEmail && <HighlightText text={contactEmail} query={searchValue} colorHighlight={true} />}
              </Typography>
            )}
          </Box>
        </Box>
      </Grid>
    </MenuItem>
  )
}

export default ResultOrderItem
